import { Routes, Route, Navigate } from 'react-router-dom';
import Dashboard from '@/pages/Dashboard/Dashboard';
import UploadManagementMain from '@/pages/UploadManagement/UploadManagementMain';
import BookDownloadMain from '@/pages/BookDownload/BookDownloadMain';
import MemberManagementMain from '@/pages/MemberManagement/MemberManagementMain';
import MBSConversionMain from '@/pages/MBSConversion/MBSConversionMain';
import EmailMagazineMain from '@/pages/EmailMagazine/EmailMagazineMain';
import DonationReportMain from '@/pages/DonationReport/DonationReportMain';
import MagazineCatchList from '@/pages/Settings/MagazineCatchList';

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Dashboard />} />

      {/* Upload Management Routes */}
      <Route path="/upload-management/*" element={<UploadManagementMain />} />

      {/* Book Download Routes */}
      <Route path="/book-download/*" element={<BookDownloadMain />} />

      {/* Member Management Routes */}
      <Route path="/member-management/*" element={<MemberManagementMain />} />

      {/* MBS Conversion Routes */}
      <Route path="/mbs-conversion/*" element={<MBSConversionMain />} />

      {/* Email Magazine Routes */}
      <Route path="/email-magazine/*" element={<EmailMagazineMain />} />

      {/* Donation Report Routes */}
      <Route path="/donation-report/*" element={<DonationReportMain />} />

      {/* Settings Routes */}
      <Route path="/admin/settings/magazine-catch" element={<MagazineCatchList />} />

      {/* 404 - Redirect to Dashboard */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

export default AppRoutes;
